import React from 'react'
import { Dialog, DialogContent, Grid, TextField, InputAdornment } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import Header from '../Header';
import { useStore } from '../../Store'
import { getErrorProps, getOptions } from '../../utils';

const ObjectDetails = ({ formik, onClose, readonly, open }) => {
    const { settings } = useStore()

    return (
        <Dialog open={open}>
            <Header backAction={onClose} title="Logboekgegevens" />
            <DialogContent>
                <Grid container>
                    <Grid item xs={12}>
                        <Alert severity="info">
                            Weer
                        </Alert>
                    </Grid>

                    {false && <Grid item xs={12}>
                        <TextField disabled={readonly} label="gemiddelde watertemperatuur" variant="standard" name="extraInfo.watertemperatuur" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.watertemperatuur")} {...formik.getFieldProps('extraInfo.watertemperatuur')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">&#8451;</InputAdornment>
                            }} />
                    </Grid>}

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="luchttemperatuur" variant="standard" name="extraInfo.luchttemperatuur" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.luchttemperatuur")} {...formik.getFieldProps('extraInfo.luchttemperatuur')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">&#8451;</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="golven" variant="standard" name="extraInfo.golven" fullWidth  {...getErrorProps(formik, "extraInfo.golven")} {...formik.getFieldProps('extraInfo.golven')} >
                            {getOptions(settings.lists["golven"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="stroming" variant="standard" name="extraInfo.stroming" fullWidth  {...getErrorProps(formik, "extraInfo.stroming")} {...formik.getFieldProps('extraInfo.stroming')} >
                            {getOptions(settings.lists["stroming"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="windkracht" variant="standard" name="extraInfo.windkracht" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.windkracht")} {...formik.getFieldProps('extraInfo.windkracht')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">Bft</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="windrichting" variant="standard" name="extraInfo.windrichting" fullWidth  {...getErrorProps(formik, "extraInfo.windrichting")} {...formik.getFieldProps('extraInfo.windrichting')} />
                    </Grid>

                    <Grid item xs={12}>
                        <Alert severity="info">
                            Ademgas
                        </Alert>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="type ademgas" variant="standard" name="extraInfo.ademgas_type" fullWidth  {...getErrorProps(formik, "extraInfo.ademgas_type")} {...formik.getFieldProps('extraInfo.ademgas_type')} >
                            {getOptions(settings.lists["ademgas_type"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="mix omschrijving" variant="standard" name="extraInfo.ademgas_mix" multiline fullWidth  {...getErrorProps(formik, "extraInfo.ademgas_mix")} {...formik.getFieldProps('extraInfo.ademgas_mix')} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="tankdruk begin duik" variant="standard" name="extraInfo.tankdruk_begin" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.tankdruk_begin")} {...formik.getFieldProps('extraInfo.tankdruk_begin')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">bar</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="tankdruk eind duik" variant="standard" name="extraInfo.tankdruk_eind" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.tankdruk_eind")} {...formik.getFieldProps('extraInfo.tankdruk_eind')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">bar</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="tankvolume" variant="standard" name="extraInfo.tankvolume" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.tankvolume")} {...formik.getFieldProps('extraInfo.tankvolume')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">liter</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="tanktype" variant="standard" name="extraInfo.tanktype" fullWidth  {...getErrorProps(formik, "extraInfo.tanktype")} {...formik.getFieldProps('extraInfo.tanktype')} >
                            {getOptions(settings.lists["tanktype"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <Alert severity="info">
                            Uitrusting
                        </Alert>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="type pak" variant="standard" name="extraInfo.pak_type" fullWidth  {...getErrorProps(formik, "extraInfo.pak_type")} {...formik.getFieldProps('extraInfo.pak_type')} >
                            {getOptions(settings.lists["pak_type"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField select disabled={readonly} label="masker" variant="standard" name="extraInfo.masker" fullWidth  {...getErrorProps(formik, "extraInfo.masker")} {...formik.getFieldProps('extraInfo.masker')} >
                            {getOptions(settings.lists["masker"])}
                        </TextField>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="lood" variant="standard" name="extraInfo.lood" type="number" fullWidth  {...getErrorProps(formik, "extraInfo.lood")} {...formik.getFieldProps('extraInfo.lood')}
                            InputProps={{
                                endAdornment: <InputAdornment position="end">kg</InputAdornment>
                            }} />
                    </Grid>

                    <Grid item xs={12}>
                        <Alert severity="info">
                            Overig
                        </Alert>
                    </Grid>

                    <Grid item xs={12}>
                        <TextField disabled={readonly} label="opmerking voor logboek" variant="standard" name="extraInfo.opmerking_logboek" multiline fullWidth  {...getErrorProps(formik, "extraInfo.opmerking_logboek")} {...formik.getFieldProps('extraInfo.opmerking_logboek')} />
                    </Grid>

                </Grid>
            </DialogContent>
        </Dialog>
    )
};

export default ObjectDetails;
